import { t } from '@lingui/core/macro';
import { NoddiDialog } from 'noddi-ui-web';
import type { UserSessionData } from 'noddi-web';
import { useOpenUserGroupPickerAfterLogin } from '../../hooks/useOpenUserGroupPickerAfterLogin';
import { CustomerSMSLogin } from './CustomerSMSLogin';

interface CustomerLoginModalProps {
  onClose: () => void;
  open: boolean;
  title?: string;
  description?: string;
  onLoginSuccess?: (userData: UserSessionData) => void;
}

export const CustomerLoginModal = ({ onClose, open, title, description, onLoginSuccess }: CustomerLoginModalProps) => {
  const openUserGroupPickerAfterLogin = useOpenUserGroupPickerAfterLogin();

  return (
    <NoddiDialog
      open={open}
      onClose={onClose}
      title={title ?? t`Sign in`}
      description={description ?? t`Please provide a phone number to continue`}
      maxWidth='sm'
    >
      <div className='px-0.5'>
        <CustomerSMSLogin
          onLoginSuccess={(userData) => {
            openUserGroupPickerAfterLogin(userData);
            onLoginSuccess?.(userData);
            onClose();
          }}
        />
      </div>
    </NoddiDialog>
  );
};
